import { motion, useWillChange, isValidMotionProp } from "framer-motion";
import { useNavigate } from "react-router";

import { useEffect, useState } from "react";
import { usePreviousPagePath } from "../../hook/usePreviousPagePath";
import { IoMdClose } from "react-icons/io";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Box,
  Flex,
  chakra,
  Button,
  shouldForwardProp,
  useColorModeValue,
  Icon,
  Image,
  AbsoluteCenter,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import SigninForm from "./signinForm";
import useCheckLogin from "../../hook/useCheckLogin";
import { resetInvalidAuth } from "../../redux/action/member/memberAction";
import { COMMON_WEB_PATH } from "../../constant";
import i18next from "i18next";
import containerImg from "./images/container.png";
import LngButton from "../../components/LayoutComponents/HeaderComponents/LngButton";
import MusicToggleButton from "../../components/LayoutComponents/HeaderComponents/MusicToggleButton";
import ReloadButton from "../../components/LayoutComponents/HeaderComponents/ReloadButton";
import AnnouncementButton from "../../components/LayoutComponents/HeaderComponents/AnnouncementButton";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const Signin = () => {
  const { t } = useTranslation();
  const i18n_header = (key) => t(`header.${key}`);
  const i18n_backend_response = (key) => t(`backend_response.${key}`);

  const navigate = useNavigate();
  const previousPage = usePreviousPagePath();

  const baseBg = useColorModeValue("light.100", "dark.100");

  const dispatch = useDispatch();

  const willChange = useWillChange();

  const { isLogin } = useCheckLogin();

  const open_registration = window?.open_registration == 1;

  useEffect(() => {
    dispatch(resetInvalidAuth());

    if (isLogin) {
      navigate("/");
    }
  }, []);

  return (
    <ChakraBox
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{ willChange }}
      display="flex"
      flexDirection={`column`}
      justifyContent={`center`}
      alignItems="center"
      zIndex="10000"
      py="10vh"
      px="10px"
      width={{
        base: "100%",
      }}
      height={{
        base: "100%",
      }}
      overflowY={`scroll`}
      position="fixed"
      top={`0px`}
      left={`0px`}
      className={`lg:backdrop-blur-none backdrop-blur-md no-scrollbar`}
      gap={"1em"}
    >
      <Box
        width={{
          md: "400px",
          base: "100%",
        }}
        borderRadius={{
          base: "common",
        }}
        borderTopRadius={{
          md: "none",
        }}
        borderBottomRadius={{
          md: "common",
        }}
        shadow="md"
        bgImage={`url(${COMMON_WEB_PATH}/now888/modal/hintBG.webp)`}
        bgSize="100% 100%"
        bgPosition="center"
        pb="10px"
        pt="50px"
        position="relative"
      >
        <AbsoluteCenter
          display="flex"
          fontSize="24px"
          color="white"
          textAlign="center"
          mt={4}
          // bgImage={`url('${COMMON_WEB_PATH}/flyDragon/hintTitleBG.webp')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          sx={{ width: "-webkit-fill-available" }}
          justifyContent="center"
          alignItems="center"
          top="-20px"
        >
          <Image
            src={`${COMMON_WEB_PATH}/now888/signIn/signIn_word${
              i18next.language == "tw" ? "" : `_${i18next.language}`
            }.png`}
            height={{
              base: "50px",
              xl: "60px",
            }}
          />
        </AbsoluteCenter>
        {/* 隱形XX */}
        <Box
          as={Link}
          to={previousPage}
          position="absolute"
          top="0"
          right="0"
          w="60px"
          h="30px"
          cursor="pointer"
        ></Box>
        <Box px="common-x">
          <Box
            width="100%"
            px="common-x"
            py="10px"
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            className="no-scrollbar"
          >
            <SigninForm />
          </Box>
        </Box>
      </Box>
      <Box
        backgroundImage={`url(${containerImg})`}
        width={"fit-content"}
        backgroundSize={"100% 100%"}
        padding={"1em 3em"}
      >
        <Flex
          gap={"0.5em"}
          justifyContent={"center"}
          alignItems={"center"}
          width={"100%"}
        >
          <LngButton />
          <MusicToggleButton />
          <ReloadButton />
          <AnnouncementButton />
        </Flex>
      </Box>
    </ChakraBox>
  );
};

export default Signin;
